import { useMap } from "./useMap";

export function Map() {
  const mapRef = useMap<HTMLDivElement>();
  return <div className="map" ref={mapRef}></div>;
}
